import { createDraftSafeSelector as createSelector } from '@reduxjs/toolkit';

import { Inject } from '@vk-hr-tek/core/ioc';

import { EventListItem as EventListEntity } from '@app/gen/events';

import { EventsMapper } from '../mappers';

import { EventsActionsRootState as RootState } from './events-actions.state';

export const selectTotal = (state: RootState) => state.eventsActions.total || 0;

export const selectBatchTotal = (state: RootState) =>
  state.eventsActions.batchTotal || null;

export const selectEventTags = (state: RootState) =>
  state.eventsActions.eventTags || [];

export const selectCancelReasons = (state: RootState) =>
  state.eventsActions.cancelReasons;

export const selectEvents = createSelector(
  [
    (state: RootState) => state.eventsActions.events,
    (_: RootState, inject: Inject) => inject(EventsMapper),
  ],
  (events, format) => {
    return events
      .filter((x): x is EventListEntity => x !== undefined)
      .map((event) => format.processListEntity({ ...event }));
  },
);

export const selectEventsForBatchOperationsBySelected = createSelector(
  [
    (state: RootState) => state.eventsActions.events,
    (state: RootState, inject: Inject) => inject(EventsMapper),
    (
      _: RootState,
      __: Inject,
      params: {
        selected: string[];
        operation: 'accept' | 'cancel';
      },
    ) => params,
  ],
  (events, format, params) => {
    const { selected, operation } = params;

    return events
      .filter((x): x is EventListEntity => x !== undefined)
      .filter(
        (event) =>
          event.batch_operations[operation] && selected.includes(event.id),
      )
      .map((event) => format.processConfirmList({ ...event }));
  },
);
